import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { ReferenceQuestionReviewType } from '../review-item';

const REFERENCE_QUESTION_REVIEW_TYPE_TO_LABEL: Record<ReferenceQuestionReviewType, string> = {
  [ReferenceQuestionReviewType.Question]: 'Question',
  [ReferenceQuestionReviewType.Markscheme]: 'Markschemes',
  [ReferenceQuestionReviewType.ExpertMarkscheme]: 'Markschemes +',
  [ReferenceQuestionReviewType.Image]: 'Images',
  [ReferenceQuestionReviewType.ExpertImage]: 'Images +',
};

const REFERENCE_QUESTION_REVIEW_TYPE_TO_CLASS_NAME: Record<ReferenceQuestionReviewType, string> = {
  [ReferenceQuestionReviewType.Question]: 'bg-sky-100 text-sky-600',
  [ReferenceQuestionReviewType.Markscheme]: 'bg-orange-100 text-orange-600',
  [ReferenceQuestionReviewType.ExpertMarkscheme]: 'bg-red-100 text-red-600',
  [ReferenceQuestionReviewType.Image]: 'bg-green-100 text-green-600',
  [ReferenceQuestionReviewType.ExpertImage]: 'bg-purple-100 text-purple-600',
};

@Component({
  selector: 'dojo-reference-question-review-type-badge',
  template: `
    @if (reviewType()) {
      <div
        [ngClass]="reviewTypeClass"
        class="inline-flex max-w-full overflow-hidden rounded-[6px] px-1.5 py-1 text-xs font-semibold"
      >
        <span class="truncate" [matTooltip]="reviewTypeLabel">{{ reviewTypeLabel }}</span>
      </div>
    }
  `,
  imports: [NgClass, MatTooltip],
})
export class ReferenceQuestionReviewTypeBadgeComponent {
  readonly reviewType = input.required<ReferenceQuestionReviewType>();

  get reviewTypeClass(): string {
    return REFERENCE_QUESTION_REVIEW_TYPE_TO_CLASS_NAME[this.reviewType()];
  }

  get reviewTypeLabel(): string {
    return REFERENCE_QUESTION_REVIEW_TYPE_TO_LABEL[this.reviewType()];
  }
}
